/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedPiiRouteImport } from './routes/_authenticated/pii'
import { Route as AuthenticatedAlertsRouteImport } from './routes/_authenticated/alerts'
import { Route as AuthenticatedPublicCaseIdIndexRouteImport } from './routes/_authenticated/$publicCaseId/index'
import { Route as AuthenticatedUserUserIdRouteImport } from './routes/_authenticated/user/$userId'
import { Route as AuthenticatedCasesPublicCaseIdRouteImport } from './routes/_authenticated/cases/$publicCaseId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPiiRoute = AuthenticatedPiiRouteImport.update({
  id: '/pii',
  path: '/pii',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAlertsRoute = AuthenticatedAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPublicCaseIdIndexRoute =
  AuthenticatedPublicCaseIdIndexRouteImport.update({
    id: '/$publicCaseId/',
    path: '/$publicCaseId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUserUserIdRoute = AuthenticatedUserUserIdRouteImport.update({
  id: '/user/$userId',
  path: '/user/$userId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCasesPublicCaseIdRoute =
  AuthenticatedCasesPublicCaseIdRouteImport.update({
    id: '/cases/$publicCaseId',
    path: '/cases/$publicCaseId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/alerts': typeof AuthenticatedAlertsRoute
  '/pii': typeof AuthenticatedPiiRoute
  '/cases/$publicCaseId': typeof AuthenticatedCasesPublicCaseIdRoute
  '/user/$userId': typeof AuthenticatedUserUserIdRoute
  '/$publicCaseId/': typeof AuthenticatedPublicCaseIdIndexRoute
}
export interface FileRoutesByTo {
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/alerts': typeof AuthenticatedAlertsRoute
  '/pii': typeof AuthenticatedPiiRoute
  '/': typeof AuthenticatedIndexRoute
  '/cases/$publicCaseId': typeof AuthenticatedCasesPublicCaseIdRoute
  '/user/$userId': typeof AuthenticatedUserUserIdRoute
  '/$publicCaseId': typeof AuthenticatedPublicCaseIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/_authenticated/alerts': typeof AuthenticatedAlertsRoute
  '/_authenticated/pii': typeof AuthenticatedPiiRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/cases/$publicCaseId': typeof AuthenticatedCasesPublicCaseIdRoute
  '/_authenticated/user/$userId': typeof AuthenticatedUserUserIdRoute
  '/_authenticated/$publicCaseId/': typeof AuthenticatedPublicCaseIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/login'
    | '/alerts'
    | '/pii'
    | '/cases/$publicCaseId'
    | '/user/$userId'
    | '/$publicCaseId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/error'
    | '/login'
    | '/alerts'
    | '/pii'
    | '/'
    | '/cases/$publicCaseId'
    | '/user/$userId'
    | '/$publicCaseId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/error'
    | '/login'
    | '/_authenticated/alerts'
    | '/_authenticated/pii'
    | '/_authenticated/'
    | '/_authenticated/cases/$publicCaseId'
    | '/_authenticated/user/$userId'
    | '/_authenticated/$publicCaseId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pii': {
      id: '/_authenticated/pii'
      path: '/pii'
      fullPath: '/pii'
      preLoaderRoute: typeof AuthenticatedPiiRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alerts': {
      id: '/_authenticated/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AuthenticatedAlertsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$publicCaseId/': {
      id: '/_authenticated/$publicCaseId/'
      path: '/$publicCaseId'
      fullPath: '/$publicCaseId/'
      preLoaderRoute: typeof AuthenticatedPublicCaseIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user/$userId': {
      id: '/_authenticated/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof AuthenticatedUserUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cases/$publicCaseId': {
      id: '/_authenticated/cases/$publicCaseId'
      path: '/cases/$publicCaseId'
      fullPath: '/cases/$publicCaseId'
      preLoaderRoute: typeof AuthenticatedCasesPublicCaseIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAlertsRoute: typeof AuthenticatedAlertsRoute
  AuthenticatedPiiRoute: typeof AuthenticatedPiiRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCasesPublicCaseIdRoute: typeof AuthenticatedCasesPublicCaseIdRoute
  AuthenticatedUserUserIdRoute: typeof AuthenticatedUserUserIdRoute
  AuthenticatedPublicCaseIdIndexRoute: typeof AuthenticatedPublicCaseIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAlertsRoute: AuthenticatedAlertsRoute,
  AuthenticatedPiiRoute: AuthenticatedPiiRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCasesPublicCaseIdRoute: AuthenticatedCasesPublicCaseIdRoute,
  AuthenticatedUserUserIdRoute: AuthenticatedUserUserIdRoute,
  AuthenticatedPublicCaseIdIndexRoute: AuthenticatedPublicCaseIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ErrorRoute: ErrorRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
